package diana.soleil.design.iraniancanadienbazzar.core.data

import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Holds the set of **saved (bookmarked) marketplace item ids** as observable state, **persisted** via
 * [AppPreferences] so bookmarks survive restarts. The Marketplace list/detail observe it to render the
 * saved state and toggle it. Device-local only — unlike [FavoritesController] there's no account
 * mirror, because peer listings are transient (they get sold/removed).
 */
class SavedItemsController(private val preferences: AppPreferences) {
    private val _saved = MutableStateFlow(preferences.savedMarketplaceItemIds)
    val saved: StateFlow<Set<String>> = _saved.asStateFlow()

    fun isSaved(itemId: String): Boolean = itemId in _saved.value

    /** Add the id if absent, remove it if present; persists and emits the new set. */
    fun toggle(itemId: String) {
        if (itemId.isBlank()) return
        val next = _saved.value.toMutableSet().apply { if (!add(itemId)) remove(itemId) }
        preferences.savedMarketplaceItemIds = next
        _saved.value = next
    }
}
